import axios from "axios";
import { del, get, post, patch,  put } from "./faculties_api_helper";
import * as url from "./faculties_url_helper";





// Get features
export const getFaculties = () => get(url.GET_FACULTIES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewFaculty = faculty => post(url.ADD_NEW_FACULTY, faculty, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateFaculty = faculty => patch(`${url.UPDATE_FACULTY}/${faculty.id}`,  faculty);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteFaculty = faculty => del(`${url.DELETE_FACULTY}/${faculty.id}`);







export {
  //getLoggedInUser,
  
  
};
